<template>
  <v-menu right offset-x transition="slide-x-reverse-transition">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <FormInput
          id="search-contractors"
          v-model="searchText"
          class="search-contractors__input"
          :placeholder="$t('Search for members')"
          :icon="searchIcon"
        >
          <template #dropdown-autocomplete>
            <div class="search-contractors__autocomplete">
              <div v-if="multi" class="search-contractors__not-found">
                {{ $t('Selected') }} {{ selectedIds.length }}
                {{ $t('team members') }}
                <Button type="borderless" size="small" @click="selectAll">
                  {{ $t('Select all') }}
                </Button>
                <Button type="borderless" size="small" @click="selectAll(false)">
                  {{ $t('Deselect all') }}
                </Button>
              </div>
              <div class="search-contractors__company-result">
                <div
                  v-for="member in sortedMembers"
                  :key="member.id"
                  class="search-contractors__contractor"
                >
                  <Checkbox
                    :checked="selectedIds.includes(member.id)"
                    class="search-contractors__contractor__checkbox"
                    @check="handleMemberCheck($event, member.id)"
                  />
                  <Contractor :contractor="member" :search-contractor="searchText" />
                </div>
              </div>
              <div class="search-contractors__add">
                {{ $t('You can add new teammate') }}
                <router-link
                  :to="{
                    query: {
                      modal: 'teamSettings',
                    },
                  }"
                  class="btn-link"
                  target="_blank"
                >
                  {{ $t('here') }}
                </router-link>
              </div>
            </div>
          </template>
        </FormInput>
      </div>
    </template>
  </v-menu>
</template>

<script>
  import SearchIcon from '@/assets/icons/search.svg';
  import FormInput from '@/components/ui/FormInput';
  import Checkbox from '@/components/ui/Checkbox';
  import Contractor from '@/components/info/Contractor';
  import removeItem from '@/utils/core/remove-item';
  import Button from '@/components/ui/Button';
  import { VMenu } from 'vuetify/lib';
  import { mapActions } from 'vuex';

  export default {
    name: 'MembersSearch',
    components: {
      FormInput,
      Checkbox,
      Contractor,
      Button,
      VMenu,
    },
    props: {
      members: {
        type: Array,
        required: true,
      },
      selectedMembersIds: {
        type: Array,
        default: () => [],
      },
      multi: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        searchIcon: SearchIcon,
        searchText: '',
        selectedIds: [],
      };
    },
    computed: {
      atLeastOnSelected() {
        return !!this.selectedIds.length;
      },
      sortedMembers() {
        let membersCopy = Object.assign([], this.members);
        membersCopy.sort((a) => {
          return a?.name?.includes(this.searchText) ? -1 : 1;
        });
        return membersCopy;
      },
    },
    created() {
      this.selectedIds = this.selectedMembersIds;
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      handleMemberCheck(state, id) {
        if (this.multi) {
          state ? this.selectedIds.push(id) : removeItem(this.selectedIds, id);
        } else {
          this.selectedIds = state ? [id] : [];
        }

        this.select();
      },
      selectAll(action = true) {
        this.selectedIds = action ? this.members.map((member) => member.id) : [];
        this.select();
      },
      select() {
        this.$emit('select', this.selectedIds);
      },
    },
  };
</script>
